import ErrorBox from '@components/common/ErrorBox';
import DwFormField from '@ui/formfield/DwFormField';
import analytics from '@stone/utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import React, { useEffect, useState } from 'react';
import { Form, FormSpy } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import SubmitButton from '@stone/ui/button/SubmitButton';
const NewsletterForm = ({ email, onSubmitSuccess, cookiepage, isPopup, title }) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = React.useState([]);
    useEffect(() => {
        let val = {};
        api.getForm('newsletters-subscribe', val).then((data) => {
            setInitialValues(Object.assign(Object.assign({}, val), { newslettersEmailSubscription: email }));
            setFormdef(data);
        });
    }, []);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'newsletters-subscribe');
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        return api
            .submitNewsletter(values, formdef)
            .then((data) => {
            if (data.success) {
                //save preferences in analytics
                let flags = [];
                let tempValues = values;
                for (const property in tempValues) {
                    if (tempValues[property] && property.includes('addtoemaillist')) {
                        let properyCleanedForGTM = '';
                        if (property == 'addtoemaillistmenwear') {
                            properyCleanedForGTM = t('description.checkbox.emailsignup.menswear.profile').toLowerCase();
                        }
                        else if (property == 'addtoemaillistjuniorwear') {
                            properyCleanedForGTM = t('description.checkbox.emailsignup.juniorwear.profile').toLowerCase();
                        }
                        else if (property == 'addtoemaillistcollaborations') {
                            properyCleanedForGTM = t('description.checkbox.emailsignup.collaborations.profile').toLowerCase();
                        }
                        flags.push(properyCleanedForGTM);
                    }
                }
                analytics.newsletter('submit');
                onSubmitSuccess();
            }
            else {
                // setErrors(data.error);
            }
        })
            .catch((e) => setErrors([e]));
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        title && React.createElement("p", { className: "newsletter-modal__subtitle" }, title),
        React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, validate: validate, render: ({ handleSubmit, form, submitting }) => {
                var _a, _b, _c, _d, _e, _f;
                const formState = form.getState();
                return (React.createElement("form", { onSubmit: handleSubmit },
                    React.createElement("div", { className: "row row-gap-40" },
                        React.createElement("div", { className: "col-lg-24" },
                            React.createElement(DwFormField, { def: formdef, name: "newslettersEmailSubscription", type: "email" })),
                        React.createElement("div", { className: "col-lg-4" },
                            React.createElement(DwFormField, { def: formdef, name: "title", type: formdef['title'].options ? 'select' : 'text', autocomplete: "honorific-prefix" })),
                        React.createElement("div", { className: "col-lg-10" },
                            React.createElement(DwFormField, { def: formdef, name: "firstname", autocomplete: "given-name" })),
                        React.createElement("div", { className: "col-lg-10" },
                            React.createElement(DwFormField, { def: formdef, name: "lastname", autocomplete: "family-name" })),
                        React.createElement("div", { className: "col-lg-12" },
                            React.createElement(DwFormField, { def: formdef, name: "gender", type: "radio", groupClassName: "form-group--gender-radio" }))),
                    React.createElement("div", { className: "newsletter-modal__radio-wrapper" },
                        React.createElement("p", { className: "newsletter-modal__subtitle" }, t('preferences.notifymeabout')),
                        React.createElement("div", { className: "checkbox-wrapper" },
                            React.createElement(DwFormField, { def: formdef, name: "addtoemaillistmenwear", type: "checkbox", checkboxChecked: ((_a = formState === null || formState === void 0 ? void 0 : formState.values) === null || _a === void 0 ? void 0 : _a.addtoemaillistmenwear) || false, controlledInput: true }),
                            React.createElement(DwFormField, { def: formdef, name: "addtoemaillistjuniorwear", type: "checkbox", checkboxChecked: ((_b = formState === null || formState === void 0 ? void 0 : formState.values) === null || _b === void 0 ? void 0 : _b.addtoemaillistjuniorwear) || false, controlledInput: true }),
                            React.createElement(DwFormField, { def: formdef, name: "addtoemaillistcollaborations", type: "checkbox", checkboxChecked: ((_c = formState === null || formState === void 0 ? void 0 : formState.values) === null || _c === void 0 ? void 0 : _c.addtoemaillistcollaborations) || false, controlledInput: true }),
                            React.createElement(DwFormField, { def: formdef, onChange: (e) => {
                                    console.log('form state', formState);
                                    if (e.target.checked) {
                                        form.change('addtoemaillistmenwear', true);
                                        form.change('addtoemaillistjuniorwear', true);
                                        form.change('addtoemaillistcollaborations', true);
                                    }
                                    else {
                                        form.change('addtoemaillistmenwear', false);
                                        form.change('addtoemaillistjuniorwear', false);
                                        form.change('addtoemaillistcollaborations', false);
                                    }
                                }, name: "addtoemaillistall", type: "checkbox", checkboxChecked: ((_d = formState === null || formState === void 0 ? void 0 : formState.values) === null || _d === void 0 ? void 0 : _d.addtoemaillistmenwear) && ((_e = formState === null || formState === void 0 ? void 0 : formState.values) === null || _e === void 0 ? void 0 : _e.addtoemaillistjuniorwear) && ((_f = formState === null || formState === void 0 ? void 0 : formState.values) === null || _f === void 0 ? void 0 : _f.addtoemaillistcollaborations), controlledInput: true })),
                        React.createElement(ErrorBox, { errors: errors })),
                    React.createElement("div", { className: "newsletter-modal__privacy-flag" },
                        React.createElement(DwFormField, { def: formdef, name: "personalInfoFlag", type: "checkbox" })),
                    React.createElement("p", { className: "newsletter-modal__required-label" }, t('label.required')),
                    React.createElement("div", { className: "row button-row" },
                        React.createElement(SubmitButton, { submitting: submitting, label: t('button.submit') })),
                    React.createElement("p", { className: "newsletter-modal__legal-label" },
                        t('preferences.newsletterterms1'),
                        ' ',
                        React.createElement("a", { href: cookiepage, target: "_blank" }, t('preferences.privacysettings.privacyandcookiepolicy')),
                        ' ',
                        t('preferences.newsletterterms2')),
                    React.createElement(FormSpy, { onChange: () => { } })));
            } })));
};
export default NewsletterForm;
